import axios, { AxiosRequestHeaders } from 'axios';
import { cloneDeep } from 'lodash';
import { LOGIN } from 'Router/routes';
import { resolveIsLegacyLogin } from 'utils/fetchData';
import { logger } from './logger';
import { ValidationError } from '.';
import { getProcessEnvUrl } from './getUrl';

const LEGACY_LOGIN_API = 'LEGACY_LOGIN_API';
const WEB_API_URL = 'WEB_API_URL';

function getTokenFromSessionStorage() {
  return sessionStorage.getItem('token');
}

const axiosInstance = axios.create({
  baseURL: `${getProcessEnvUrl('GATEWAY_URL')}/webapi`,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  } as AxiosRequestHeaders,
});

// This is a request interceptor that will run before every request.
// It will add the Authorization header with the token from sessionStorage.
axiosInstance.interceptors.request.use(
  async function getInternalAxiosRequestConfig(config) {
    // Already has Authorization header
    if (config.headers.Authorization) {
      return config;
    }

    const newConfig = cloneDeep(config);

    const isLegacyLogin = await resolveIsLegacyLogin();
    const token = getTokenFromSessionStorage();

    newConfig.baseURL = getProcessEnvUrl(
      isLegacyLogin ? LEGACY_LOGIN_API : WEB_API_URL,
    );

    if (isLegacyLogin) {
      newConfig.headers.Authorization = `Basic ${token}`;
    }

    return newConfig;
  },
);

axiosInstance.interceptors.response.use(
  function getInternalAxiosResponseConfig(response) {
    return response;
  },
  function onRejected(error) {
    if (error.response.status >= 500) {
      logger.error('[Axios interceptor] webapi error', error);
    } else {
      logger.error(
        `request: ${error.response.request.responseURL} response parse`,
        {
          request_url: error.response.config.url,
          error,
        },
      );
    }

    if (error.response.status === 401) {
      sessionStorage.removeItem('token');
      window.location.assign(`${LOGIN}?sessionExpired=true`);
    }

    const isValidationError =
      error.response.status === 400 && error.response.data.errors;
    if (isValidationError) {
      return Promise.reject(new ValidationError(error.response.data.errors));
    }

    return Promise.reject(error);
  },
);

export default axiosInstance;
